import useAppSelector from "./base/useAppSelector";

const useViewPageObject = () => {
  return useAppSelector((state) => {
    return state.IpoView.ipoViewPage.object;
  });
};

export default useViewPageObject;
